<template>
  <div class="dialogFooterContainer">
    <v-btn @click="$emit('cancel')" rbt-target="cancelOperation" :disabled="loading" large>
      <v-icon left>action_remove_circle</v-icon>
      <span>{{ $t("WorkspaceEdit.appDetails.buttons.cancel") }}</span>
    </v-btn>

    <v-btn @click="deleteApp" rbt-target="deleteAppDetails" :disabled="!hasPermission || loading" large>
      <v-icon left>action_trash</v-icon>
      <span>{{ $t("WorkspaceEdit.appDetails.buttons.delete") }}</span>
    </v-btn>

    <v-btn
      @click="save"
      color="primary"
      rbt-target="saveAppDetails"
      :disabled="!hasPermission || loading || disableSave"
      large
    >
      <v-icon left>action_save</v-icon>
      <span v-if="isUpdatingService">{{ $t("WorkspaceEdit.appDetails.buttons.saveAndDeploy") }}</span>
      <span v-else>{{ $t("WorkspaceEdit.appDetails.buttons.save") }}</span>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "@vue/composition-api"
import { raiseConfirmation } from "@/utils/event-bus"
import { translate } from "@/plugins/i18n"
import { WorkspaceStatusEnum } from "@/types/workspace"
import { useStore } from "@/composable/useStore"

export default defineComponent({
  name: "DialogFooter",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disableSave: {
      type: Boolean,
      default: false
    },
    isService: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const { usersModule, spaceModule } = useStore()

    const hasPermission = computed(() => {
      return usersModule.hasEditorPermissions
    })

    const isUpdatingService = computed(() => {
      const space = spaceModule.watching

      if (space) {
        const spaceNotDraft = space.status !== WorkspaceStatusEnum.Draft
        return props.isService && spaceNotDraft
      }

      return false
    })

    const deleteApp = async () => {
      if (await raiseConfirmation({ text: translate("WorkspaceEdit.appDetails.confirm.deleteApp") })) {
        ctx.emit("remove")
      }
    }

    const save = async () => {
      ctx.emit("save")
    }

    return {
      isUpdatingService,
      hasPermission,
      deleteApp,
      save
    }
  }
})
</script>
